export interface MemoTagId {__memoTagId: number}

export default class MemoTag {
  id!: MemoTagId;
  code!: number;
  name!: string;
}
